import React from 'react';

const MyComponent = () => {
  return (
    <>
      <div className={'d-flex flex-wrap '}>


        <div className={''}>
          <div className={'mx-2 my-1'}>
            بارگزاری فایل : <span className={'monoFont'}>Ctrl+O</span>
          </div>
          <div className={'mx-2 my-1'}>
            ذخیره در فایل : <span className={'monoFont'}>Ctrl+S</span>
          </div>
        </div>

        <div className={''}>
          <div className={'mx-2 my-1'}>
            چاپ جدول: <span className={'monoFont'}>Ctrl+P</span>
          </div>
          <div className={'mx-2 my-1'}>
            ثبت  : <span className={'monoFont'}>Ctrl + Enter</span>
          </div>
        </div>


      </div>

    </>
  );
};

export default MyComponent;
